import actions from './actions'
import mutations from './mutations'
// TODO: deprecate
export default {
  state: {
    availableDates: [],
    startDate: null,
    endDate: null
  },
  getters: {
    startDate: (state) => {
      return state.startDate
    },
    endDate: (state) => {
      return state.endDate
    },
    isValidStartDate: state => startDate => (
      state.availableDates.filter(date => date.from === startDate).length > 0
    ),
    dateRange: state => {
      return {
        availableDates: state.availableDates,
        startDate: state.startDate,
        endDate: state.endDate
      }
    }
  },
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/dateRange/store/index.js